var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPallets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 14,
    viewBox: "0 0 31 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5307 0H0V13.7135H14.5307V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39732 0H5.12701V5.46725H9.39732V0Z",
    fill: "#4083BF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3988 0H15.868V13.7135H30.3988V0Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2654 0H20.9951V5.46725H25.2654V0Z",
    fill: "#4083BF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPallets);
export default __webpack_public_path__ + "static/media/pallets.c127fdd70ee7a1722a65a238bdf8344a.svg";
export { ForwardRef as ReactComponent };